import { SELECT_UNIVERSE } from "./types"

export const selectUniverse = (data) => {
    return {
      type: SELECT_UNIVERSE,
      payload: data
    }
  }
